import { UNAUTHORIZED } from "constants/auth.constants";
import * as constants from "constants/shares/library.constants";
import { combineReducers } from "redux";

import pagination from "../pagination";
import { getItemsById } from "../utils";
import {makeListReducer} from "../list";

const initialListState = {
  loading: false,
  ready: false,
  error: false,
  items: [],
  itemsById: {},
  count: 0,
  allSelected: false,
  anySelected: false,
  columns: {
    topic: true,
    holders: true,
    created: true,
    updated: true,
    hide_questions: true,
    num_users: true,
    num_total_certificates: true,
    training_minutes: true,
    status: true,
  },
};

const librarySharesReducer = (state = initialListState, action) => {
  switch (action.type) {
    case constants.LIBRARY_SHARES.REQUEST:
      return {
        ...state,
        loading: true,
        ready: false,
        error: false,
      };
    case constants.LIBRARY_SHARES.FAILURE:
      return {
        ...state,
        items: [],
        itemsById: {},
        count: 0,
        loading: false,
        ready: false,
        error: true,
      };
    case constants.LIBRARY_SHARES.SUCCESS: {
      const { results: items, count } = action.data;
      return {
        ...state,
        loading: false,
        ready: true,
        allSelected: false,
        anySelected: false,
        items,
        count,
        itemsById: getItemsById(items),
      };
    }
    case constants.SELECT: {
      let { items: shareLinks } = state;
      shareLinks = shareLinks.map((it) => {
        if (it.id === action.data.id) {
          it.selected = !it.selected;
        }
        return it;
      });
      return {
        ...state,
        items: shareLinks,
        itemsById: getItemsById(shareLinks),
        allSelected: shareLinks.every((it) => it.selected === true),
        anySelected: shareLinks.some((it) => it.selected === true),
      };
    }
    case constants.SELECT_ALL: {
      let { items: shareLinks, allSelected } = state;
      allSelected = !allSelected;
      shareLinks = shareLinks.map((it) => {
        it.selected = allSelected;
        return it;
      });
      return {
        ...state,
        items: shareLinks,
        itemsById: getItemsById(shareLinks),
        allSelected,
        anySelected: shareLinks.some((it) => it.selected === true),
      };
    }
    case constants.SHOW_COLUMNS: {
      const names = action.data;
      const columns = Object.keys(state.columns);

      return {
        ...state,
        columns: columns.reduce(
          (obj, key) => ({ ...obj, [key]: names.includes(key) }),
          {},
        ),
      };
    }
    case UNAUTHORIZED:
      return initialListState;
    default:
      return state;
  }
};

const initialState = {
  loading: false,
  ready: false,
  error: false,
  topic: null,
  request_data: false,
  hide_questions: false,
};

const libraryShareReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.LIBRARY_SHARE_CREATE.REQUEST:
    case constants.LIBRARY_SHARE_GET.REQUEST:
    case constants.LIBRARY_SHARE_UPDATE.REQUEST:
      return {
        ...state,
        loading: true,
        ready: false,
        error: false,
      };
    case constants.LIBRARY_SHARE_CREATE.FAILURE:
    case constants.LIBRARY_SHARE_GET.FAILURE:
    case constants.LIBRARY_SHARE_UPDATE.FAILURE:
      return {
        ...state,
        loading: false,
        ready: false,
        error: true,
      };
    case constants.LIBRARY_SHARE_CREATE.SUCCESS:
    case constants.LIBRARY_SHARE_GET.SUCCESS:
    case constants.LIBRARY_SHARE_UPDATE.SUCCESS: {
      const data = action.data;
      return {
        ...data,
        loading: false,
        ready: true,
      };
    }
    case UNAUTHORIZED:
      return initialListState;
    default:
      return state;
  }
};

const paginationReducer = pagination(constants.PAGINATION, {
  orderby: "-created",
});

export default combineReducers({
  list: makeListReducer(librarySharesReducer, "library"),
  pagination: paginationReducer,
  current: libraryShareReducer,
});
